<template>
  <div>
    <el-dialog
      width="1200px"
      title="文件下载申请"
      class="dialogEDA"
      :before-close="close"
      :close-on-click-modal="false"
      :visible.sync="dialogDownloadVisible"
    >
      <div class="title-class base-flex__between">
        <div class="titleCls pad_bot_cls">我的申请</div>
        <div class="base-margin__right-10">
          <el-select
            v-model="applySelectValue"
            @change="resetApplyList"
            class="base-width__240 base-margin__right-10"
            placeholder="请选择筛选类型"
          >
            <el-option v-for="item in applySelectList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button
            class="refresh dialogTrueCls base-text-align__right"
            icon="el-icon-refresh"
            title="刷新"
            type="text"
            @click="getProjectApplyList"
          ></el-button>
        </div>
      </div>
      <div class="table">
        <el-table align="center" :data="tableData" v-loading="tableDataLoading">
          <el-table-column prop="id" label="ID" width="100" align="center"></el-table-column>
          <el-table-column label="审批类型" width="120" align="center">
            <template slot-scope="scope">
              {{ filterApplyScene(scope.row.scene) }}
            </template>
          </el-table-column>
          filterApplyScene
          <el-table-column prop="content" label="申请内容" align="center"></el-table-column>
          <el-table-column prop="applyUser.name" label="申请人" align="center" width="120"></el-table-column>
          <el-table-column prop="createTime" label="申请时间" align="center" width="200"></el-table-column>
          <el-table-column prop="status" label="当前状态" width="80">
            <template slot-scope="scope">
              {{ filterApplyStatus(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column label="审批时间" align="center" width="200">
            <template slot-scope="scope">
              {{ filterUpdateTime(scope.row) }}
            </template>
          </el-table-column>

          <!-- 操作  v-if="isOwner"-->
          <el-table-column label="操作" align="center" width="140">
            <template slot-scope="scope">
              <el-button class="buttonBackground_cls" @click="openDownload(scope.row.id)" type="text"
                         v-if="scope.row.status === 3"
                >下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <el-pagination
        align="right"
        @size-change="handleSizeApplyChange"
        @current-change="onCurrentApplyChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableDataTotal"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="buttonBackground_cls"
          @click="openfileManagement"
        >
          对象存储文件管理
        </el-button>
        <el-button
          class="buttonBackground_cls"
          @click="openDirectory"
        >
          下载服务器文件
        </el-button>
      </div>
    </el-dialog>
    <Directory ref="directory"></Directory>
    <!-- 下载文件弹窗 -->
    <DownloadFile ref="downloadFileRef"></DownloadFile>
    <ApprovalDownloadFile ref="approvalDownloadFile"></ApprovalDownloadFile>
  </div>
</template>
<script>
import {applyStatusList, filterApplyScene, filterApplyStatus, processTime} from '@/common/utils/utils';
import { postRequest } from '@/common/libs/request';
import { mapGetters, mapState } from 'vuex';
import Directory from '@/views/remoteDestop/components/directoryDialog';
import ApprovalDownloadFile from '@/views/approval/components/downloadFile';
import DownloadFile from '@/views/remoteDestop/components/downloadFile';

export default {
  name: 'downloadFile',
  props: {
    linuxName: String,
    homePath: String,
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  components: {
    Directory,
    DownloadFile,
    ApprovalDownloadFile,
  },
  watch: {
    linuxName(oldVal) {
      this.newLinuxName = oldVal;
    },
  },
  data() {
    return {
      checkedFilesList: [], // 所选的文件列表
      downloadLoading: false, // 下载文件loading
      directoryVisible: false,
      pathInput: '',
      directoryList: [],
      dirPath: '',
      newLinuxName: '',
      processTime,
      filterApplyScene,
      filterApplyStatus,
      applyPageIndex: 1,
      applyPageLimit: 10, // 每一页条数
      tableDataTotal: 0,
      tableData: [],
      dialogDownloadVisible: false,
      applySelectValue: 0,
      applySelectList: applyStatusList,
      tableDataLoading: false,
    };
  },

  methods: {
    // 关闭同步服务器文件 同步下载列表
    openDirectory() {
      this.$refs.directory.openDirectoryDialog(this.newLinuxName, this.homePath);
    },

    openDownload(id) {
      const data = {
        applyId: id,
      };

      this.$refs.approvalDownloadFile.openDownload(data);
    },

    openfileManagement() {
      this.$refs.downloadFileRef.openDownload();
    },

    filterUpdateTime(item) {
      let updateTime = '_';
      // { label: '所有状态', value: 0 },
      // { label: '审批中', value: 1 },
      // { label: '已拒绝', value: 2 },
      // { label: '已通过', value: 3 },
      // { label: '已撤回', value: 4 },
      // { label: '已过期', value: 5 },
      // { label: '提交审批中', value: 6 },
      // { label: '提交失败', value: 7 },
      if (item.status !== 1 && item.status !== 4 && item.status !== 5) {
        updateTime = item.updateTime;
      }
      return updateTime;
    },

    /**
     * 打开申请文件列表
     * @param applyId 申请ID
     */
    openApplyDownload() {
      this.applySelectValue = 0;
      this.pageIndex = 1; // 分页index
      this.currentPage = 1; // 当前页数
      this.checkedFilesList = [];
      this.getProjectApplyList();
    },

    resetApplyList() {
      this.pageIndex = 1; // 分页index
      this.currentPage = 1; // 当前页数
      this.checkedFilesList = [];
      this.getProjectApplyList();
    },

    /**
     * 申请列表
     */
    async getProjectApplyList() {
      this.tableDataLoading = true;
      const offset = this.applyPageLimit * (this.applyPageIndex - 1);
      postRequest('/api/eda/common/project/getProjectApplyList', {
        scene: 2,
        status: this.applySelectValue,
        offset,
        limit: this.applyPageLimit,
      }).then((res) => {
        this.tableData = res.list || [];
        this.tableDataTotal = res.total || 0;
        this.dialogDownloadVisible = true;
        this.tableDataLoading = false;
      })
        .catch(() => {
          this.tableDataLoading = false;
          this.$message('获取申请列表失败，请重新再试');
        });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentApplyChange(val) {
      this.applyPageIndex = val;
      this.getProjectApplyList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeApplyChange(val) {
      this.applyPageLimit = val;
      this.getProjectApplyList();
    },

    /**
     * 弹窗关闭
     */
    close() {
      this.pageIndex = 1; // 分页index
      this.currentPage = 1; // 当前页数
      this.checkedFilesList = [];
      this.dialogDownloadVisible = false;
      this.downloadLoading = false;
      this.applySelectValue = 0;
    },
  },
};

</script>
<style lang="scss" scoped>
.dialogEDA {
  ::v-deep .el-dialog__header {
    text-align: left !important;
  }
}

// table 背景颜色+padding10px
.table {
  //background: #fff;
  //padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    min-height: 264px;
    margin-bottom: 10px;
  }
}

.dialogTrueCls {
  background-image: none !important;
}
.buttonBackground_cls {
  background: none !important;
}
</style>
